import formatcoords from "formatcoords";
import html from "nanohtml";
import nanomorph from "nanomorph";
import { elements } from "./base";

const ERROR_HIDDEN_CLASS = "dn";

export const latLngToDmX = (latLng) => {
	const DmX = formatcoords(latLng).format("D m X").split(" ");
	const retEn = DmX[2] === "N" ? "nord" : "sør";
	const retTo = DmX[5] === "E" ? "øst" : "vest";
	return { DmX, retEn, retTo };
};

function createDmXHtml({ DmX, retEn, retTo }, clazz = "") {
	return html`
		<div class="${clazz}">
			<p class="f6">${DmX[0]}° ${parseFloat(DmX[1]).toFixed(2)}' ${retEn}</p>
			<p class="f6">${DmX[3]}° ${parseFloat(DmX[4]).toFixed(2)}' ${retTo}</p>
		</div>
	`;
}

export const renderDmX = ({ DmX, retEn, retTo }) => {
	const markupStr = createDmXHtml({ DmX, retEn, retTo }, "map-DmX tc");
	const markup = html`${markupStr}`;
	nanomorph(elements.mapDmX, markup);
};

export const toggleHideBtn = () => elements.sFormBtn.classList.toggle("hide"); // bundle.css, display: none

export const renderForm = (latLng, bbox) => {
	const { DmX, retEn, retTo } = latLngToDmX(latLng);

	const lat = latLng.lat || latLng[0];
	const lng = latLng.lng || latLng[1];

	const markup = html`
		<div
			id="map-formDiv"
			class="w-100 absolute z-9999 top-0"
			style="height:0;"
		>
			<form
				id="map-form"
				action="./mail.php"
				method="post"
				novalidate
				class="w-100 db bg-secondary white fw5 f5 pa3"
			>
				<div class="mb3">
					<label
						class="db f5 fw5"
						for="name"
						>Navngi stedet (sted, adresse, kallenavn, e.l.)
						<input
							id="name"
							class="input w-100"
							type="text"
							name="name"
							placeholder="Gi navn til kartposisjonene din"
							aria-describedby="name-error"
							autofocus
							required
							maxlength="60"
						/>
						<p
							id="name-error"
							class="f6 mt2 dn red"
							aria-live="polite"
						>
							<span class="dn validation-msg-required">Navnet må fylles ut.</span>
							<span class="dn validation-msg-too-long">Navnet kan ikke være lengre enn 60 tegn.</span>
						</p>
					</label>
				</div>
				<div class="form-dmx mb3 dn">
					<p class="f6">Min posisjon er:</p>
					${createDmXHtml(latLngToDmX(latLng), "")}
				</div>
				<div class="mb3">
					<label
						class="db f5 fw5"
						for="email"
						>E-post
						<input
							id="email"
							class="input w-100"
							type="email"
							name="email"
							placeholder="navn@epost.no"
							aria-describedby="email-error"
							required
						/>
						<p
							id="email-error"
							class="f6 mt2 dn red"
							aria-live="polite"
						>
							<span class="dn validation-msg-required">Skriv inn e-postadressen din.</span>
							<span class="dn validation-msg-type-mismatch"
								>Skriv inn en gyldig e-postadresse, for eksempel navn@epost.no.</span
							>
						</p>
					</label>
				</div>

				<div class="mb3 f6">
					<label
						class=""
						for="nyhetsbrev-j"
					>
						<input
							id="nyhetsbrev-j"
							class="input-nyhet"
							type="radio"
							name="nyhetsbrev"
							value="J"
							aria-describedby="nyhetsbrev-error"
							required
						/>
						Ja takk, jeg er over 18 år og ønsker å motta e-post om Stiftelsen Norsk Luftambulanses
						livsviktige arbeid
					</label>
				</div>
				<div class="mb3 f6">
					<label
						class=""
						for="nyhetsbrev-n"
					>
						<input
							id="nyhetsbrev-n"
							class="input-nyhet"
							type="radio"
							name="nyhetsbrev"
							value="N"
							aria-describedby="nyhetsbrev-error"
						/>
						Nei takk, jeg ønsker ikke å motta e-post om Stiftelsen Norsk Luftambulanses livsviktige arbeid
						(Du vil allikevel motta din nødplakat)</label
					>
				</div>
				<p
					id="nyhetsbrev-error"
					class="f6 mb3 dn red"
					aria-live="polite"
				>
					Velg om du vil motta e-post om Stiftelsen Norsk Luftambulanses arbeid.
				</p>

				<input
					name="lat"
					value="${lat}"
					type="hidden"
				/>
				<input
					name="lng"
					value="${lng}"
					type="hidden"
				/>
				<input
					name="bbox"
					value="${bbox}"
					type="hidden"
				/>
				<input
					name="dmx1"
					value="${DmX[0]} grader ${parseFloat(DmX[1]).toFixed(2)} minutter ${retEn}"
					type="hidden"
				/>
				<input
					name="dmx2"
					value="${DmX[3]} grader ${parseFloat(DmX[4]).toFixed(2)} minutter ${retTo}"
					type="hidden"
				/>
				<div class="mb3">
					<input
						id="btn-send"
						class="input w-100 primary b--primary hover-bg-primary hover-b-primary hover-white"
						type="submit"
						value="SEND MEG NØDPLAKATEN"
					/>
					<button
						id="avbryt"
						class="bn bg-transparent underline white ml3 pa3 dn"
						type="button"
						href="#"
					>
						Avbryt
					</button>
				</div>
			</form>
			<button
				class="arrow-up-white bg-secondary"
				type="button"
			>
				<img src="./images/arrow-up-white.svg" />
			</button>
		</div>
	`;

	nanomorph(elements.formDiv, markup);

	const form = document.getElementById("map-form");
	const nameInput = document.getElementById("name");
	const emailInput = document.getElementById("email");
	const nameError = document.getElementById("name-error");
	const emailError = document.getElementById("email-error");
	const newsletterError = document.getElementById("nyhetsbrev-error");
	const newsletterInputs = form ? form.querySelectorAll('input[name="nyhetsbrev"]') : [];
	const nameMessages = {
		required: nameError ? nameError.querySelector(".validation-msg-required")?.textContent || "" : "",
		tooLong: nameError ? nameError.querySelector(".validation-msg-too-long")?.textContent || "" : "",
	};
	const emailMessages = {
		required: emailError ? emailError.querySelector(".validation-msg-required")?.textContent || "" : "",
		typeMismatch: emailError ? emailError.querySelector(".validation-msg-type-mismatch")?.textContent || "" : "",
	};
	const newsletterMessages = {
		required: newsletterError ? newsletterError.textContent.trim() : "",
	};

	if (nameError) nameError.textContent = "";
	if (emailError) emailError.textContent = "";
	if (newsletterError) newsletterError.textContent = "";
	const getValidationMessage = (input, errorNode) => {
		if (!input || !errorNode) return "";

		const messages =
			errorNode.id === "name-error"
				? nameMessages
				: errorNode.id === "email-error"
					? emailMessages
					: newsletterMessages;

		if (input.validity.valueMissing) return messages.required || "";
		if (input.validity.tooLong) return messages.tooLong || "";
		if (input.validity.typeMismatch) return messages.typeMismatch || "";

		return "";
	};

	const showError = (errorNode, message) => {
		if (!errorNode) return;
		errorNode.textContent = message;
		errorNode.classList.remove(ERROR_HIDDEN_CLASS);
	};

	const hideError = (errorNode) => {
		if (!errorNode) return;
		errorNode.textContent = "";
		errorNode.classList.add(ERROR_HIDDEN_CLASS);
	};

	if (form) {
		form.addEventListener("submit", (event) => {
			if (!form.checkValidity()) {
				event.preventDefault();
				const firstInvalid = form.querySelector(":invalid");
				if (firstInvalid) firstInvalid.focus();
			}
		});
	}

	if (form && nameInput) {
		nameInput.addEventListener("invalid", () => {
			nameInput.setAttribute("aria-invalid", "true");
			showError(nameError, getValidationMessage(nameInput, nameError));
		});

		nameInput.addEventListener("input", () => {
			if (nameInput.checkValidity()) {
				nameInput.removeAttribute("aria-invalid");
				hideError(nameError);
			} else if (nameError) {
				showError(nameError, getValidationMessage(nameInput, nameError));
			}
		});
	}

	if (form && emailInput) {
		emailInput.addEventListener("invalid", () => {
			emailInput.setAttribute("aria-invalid", "true");
			showError(emailError, getValidationMessage(emailInput, emailError));
		});

		emailInput.addEventListener("input", () => {
			if (emailInput.checkValidity()) {
				emailInput.removeAttribute("aria-invalid");
				hideError(emailError);
			} else if (emailError) {
				showError(emailError, getValidationMessage(emailInput, emailError));
			}
		});
	}

	if (form && newsletterInputs.length) {
		const clearNewsletterValidity = () => {
			newsletterInputs.forEach((input) => {
				input.removeAttribute("aria-invalid");
			});
			hideError(newsletterError);
		};

		newsletterInputs.forEach((input) => {
			input.addEventListener("invalid", () => {
				newsletterInputs.forEach((radioInput) => radioInput.setAttribute("aria-invalid", "true"));
				showError(newsletterError, getValidationMessage(input, newsletterError));
			});

			input.addEventListener("change", clearNewsletterValidity);
			input.addEventListener("input", clearNewsletterValidity);
		});
	}
};
